module.exports = __webpack_public_path__ + "OpenSans-ExtraBold.8c5c497a47304f276f99.svg";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.svg
// module id = ../../../../npm-font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.svg
// module chunks = styles